import { SvgComponentProps, Svg } from './svg-component';

export const CostFillIcon = ({ size, ...rest }: SvgComponentProps) => (
    <Svg width={size || 17} height={size || 16} viewBox="0 0 17 16" fill="none" {...rest}>
        <path
            d="M14.279 10.302c1.185.54 1.916 1.282 1.916 2.098 0 1.654-2.995 2.996-6.684 2.996S2.826 14.054 2.826 12.4q0-.135.027-.269c1.177.334 2.54.518 4.027.518 3.302 0 5.992-.91 7.398-2.347Z"
            fill="currentColor"
        />
        <path
            d="M16.195 3.6c0-1.653-2.995-2.995-6.684-2.995S2.826 1.947 2.826 3.601s2.996 2.995 6.685 2.995 6.684-1.342 6.684-2.995Z"
            fill="currentColor"
        />
        <path
            d="M13.564 7.848v.028c0 1.653-2.996 2.996-6.684 2.996-3.69 0-6.685-1.343-6.685-2.996 0-.78.666-1.49 1.756-2.023 1.355 1.538 4.127 2.52 7.56 2.52 1.498 0 2.87-.186 4.053-.525Z"
            fill="currentColor"
        />
    </Svg>
);
